const dotenv = require('dotenv');

dotenv.config();

// eslint-disable-next-line prettier/prettier
const dev = process.env.REACT_APP_DEV.localeCompare('true') === 0;
export const url = dev ? process.env.REACT_APP_URL_JS_DEV : process.env.REACT_APP_URL_JS_PROD;
export const urlLatte = dev ? process.env.REACT_APP_URL_PHP_DEV : process.env.REACT_APP_URL_PHP_PROD;
